import Vue from 'vue'

const POST_CATEGORY = {
	UPDATE: post => {
		return Vue.$api.patch('/post-category', post)
	},

}

export default POST_CATEGORY
